import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "-frame-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "el-aside-logo" }, [
  /*#__PURE__*/_createTextVNode(" 商户管理系统 "),
  /*#__PURE__*/_createElementVNode("div", { class: "m-version" }, "v2022.01.15")
], -1)
const _hoisted_3 = { class: "el-aside-group -scroll-y" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_container, {
    class: _normalizeClass('-frame' + (_ctx.PageLoadFinish?'':' -hide')),
    "element-loading-text": "拼命加载中",
    "element-loading-background": "rgba(0, 0, 0, 0.8)",
    "element-loading-spinner": "el-icon-loading"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_aside, { width: _ctx.asideWidth }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRoutes, (item0, index0) => {
                return (_openBlock(), _createElementBlock(_Fragment, null, [
                  (index0==_ctx.TopActiveIndex)
                    ? (_openBlock(), _createBlock(_component_el_menu, {
                        key: 0,
                        "default-active": _ctx.LeftActiveIndex,
                        "background-color": "#233042",
                        "text-color": "#d6e9f3",
                        "default-collapse": _ctx.userRoutes[_ctx.TopActiveIndex].collapse,
                        "default-openeds": _ctx.userRoutes[_ctx.TopActiveIndex].openeds
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userRoutes[_ctx.TopActiveIndex].children, (item1, index1) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (!item1.children && !item1.hide)
                                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                    key: 0,
                                    index: item1.name,
                                    onClick: ($event: any) => ($options.forwrad(item1))
                                  }, {
                                    default: _withCtx(() => [
                                      (item1.icon)
                                        ? (_openBlock(), _createElementBlock("i", {
                                            key: 0,
                                            class: _normalizeClass(item1.icon)
                                          }, null, 2))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", null, _toDisplayString(item1.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["index", "onClick"]))
                                : (!item1.hide)
                                  ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                                      key: 1,
                                      index: item1.name
                                    }, {
                                      title: _withCtx(() => [
                                        (item1.icon)
                                          ? (_openBlock(), _createElementBlock("i", {
                                              key: 0,
                                              class: _normalizeClass(item1.icon)
                                            }, null, 2))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", null, _toDisplayString(item1.title), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.children, (item2, index2) => {
                                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                                            (!item2.children)
                                              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                                                  key: 0,
                                                  index: item2.name,
                                                  onClick: ($event: any) => ($options.forwrad(item2))
                                                }, {
                                                  default: _withCtx(() => [
                                                    (item2.icon)
                                                      ? (_openBlock(), _createElementBlock("i", {
                                                          key: 0,
                                                          class: _normalizeClass(item2.icon)
                                                        }, null, 2))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("span", null, _toDisplayString(item2.title), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["index", "onClick"]))
                                              : (_openBlock(), _createBlock(_component_el_sub_menu, {
                                                  key: 1,
                                                  index: item2.name
                                                }, {
                                                  title: _withCtx(() => [
                                                    (item2.icon)
                                                      ? (_openBlock(), _createElementBlock("i", {
                                                          key: 0,
                                                          class: _normalizeClass(item2.icon)
                                                        }, null, 2))
                                                      : _createCommentVNode("", true),
                                                    _createElementVNode("span", null, _toDisplayString(item2.title), 1)
                                                  ]),
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.children, (item3, index3) => {
                                                      return (_openBlock(), _createBlock(_component_el_menu_item, {
                                                        index: item2.name,
                                                        onClick: ($event: any) => ($options.forwrad(item3))
                                                      }, {
                                                        default: _withCtx(() => [
                                                          (item3.icon)
                                                            ? (_openBlock(), _createElementBlock("i", {
                                                                key: 0,
                                                                class: _normalizeClass(item3.icon)
                                                              }, null, 2))
                                                            : _createCommentVNode("", true),
                                                          _createElementVNode("span", null, _toDisplayString(item3.title), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["index", "onClick"]))
                                                    }), 256))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["index"]))
                                          ], 64))
                                        }), 256))
                                      ]),
                                      _: 2
                                    }, 1032, ["index"]))
                                  : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        ]),
                        _: 1
                      }, 8, ["default-active", "default-collapse", "default-openeds"]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 256))
            ]),
            _: 1
          }, 8, ["width"])
        ])
      ]),
      _createVNode(_component_el_container, { direction: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_main, { class: "-frame-main" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view, { key: _ctx.key }, {
                    default: _withCtx(({ Component }) => [
                      (_openBlock(), _createBlock(_KeepAlive, null, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                      ], 1024))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"])), [
    [_directive_loading, false]
  ])
}